/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Button, Chip, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, Pagination, Spinner, Table, TableBody, TableCell, TableColumn, TableHeader, TableRow, Tooltip } from '@nextui-org/react';
import { IconEdit, IconPlus, IconTrash } from '@tabler/icons-react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { useSelector } from 'react-redux'
import { Constants } from '../../../../utils';
import { TeacherGroupService } from '../../../../services';
// import ModalCreateGrade from './create-grade';
import ModalCreateGroup from './create-group';
import ModalCreateMultipleSection from './create-multiple-sections';
import ModalCreateSection from './create-section';
import Render from '../../../../components/render';
import PaidAction from '../../../../components/paid-action';

const MODAL_ACTION = {
  NONE: 0,
  CREATE: 1,
  CREATE_MULTIPLE_SECTIONS: 2,
  VIEW_LAPSES: 3,
  VIEW_SECTIONS: 4,
  EDIT: 5,
  DELETE: 6,
  CREATE_SECTION: 7,
}

const Groups = ({ filters }) => {
  const [selectedItem, setSelectedItem] = useState();
  const [currentSchoolYear, setCurrentSchoolYear] = useState();
  const [modalAction, setModalAction] = useState(MODAL_ACTION.NONE);
  const { data, goToPage, isLoading, pagination, reload, deleteItem, deleteGrade, user, download } = useFetchTable(filters);

  const onSelectItem = (item, action, currentSchoolYear = null) => {
    setSelectedItem(item);
    setCurrentSchoolYear(currentSchoolYear || item?.id)
    setModalAction(action);
  }

  const closeModal = (reloading = false) => {
    setSelectedItem(null);
    setCurrentSchoolYear(null)
    setModalAction(MODAL_ACTION.NONE);
    if (reloading) reload();
  }

  const isFreelanceTeacher = user?.level_id === Constants.USER.LEVELS.PROFESSOR && user?.school_id === null;


  return (
    <div>
      {isLoading && (
        <div className="w-screen h-screen fixed inset-0 z-[70] flex justify-center items-center bg-white/30">
          <Spinner />
        </div>
      )}

      <Modal
        size="md"
        isOpen={modalAction !== MODAL_ACTION.NONE}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            if (modalAction === MODAL_ACTION.VIEW_LAPSES) return (
              <ModalViewLapses item={selectedItem} />
            )
            if (modalAction === MODAL_ACTION.VIEW_SECTIONS) return (
              <ModalViewSections
                item={selectedItem}
                isFreelanceTeacher={isFreelanceTeacher}
                onSelectItem={onSelectItem}
                onDelete={(id) => {
                  deleteGrade(id)
                  closeModal(true)
                }}
              />
            )
            if (modalAction === MODAL_ACTION.CREATE_MULTIPLE_SECTIONS) return (
              <ModalCreateMultipleSection
                currentSchoolYearId={currentSchoolYear}
                onClose={onClose}
                onSuccess={() => closeModal(true)}
              />
            )

            if (modalAction === MODAL_ACTION.CREATE_SECTION) return (
              <ModalCreateSection
                item={selectedItem}
                currentSchoolYearId={currentSchoolYear}
                onClose={onClose}
                onSuccess={() => closeModal(true)}
              />
            )

            if ([MODAL_ACTION.CREATE, MODAL_ACTION.EDIT].includes(modalAction)) {
              return (
                <ModalCreateGroup
                  item={selectedItem}
                  onClose={onClose}
                  onSuccess={() => closeModal(true)}
                />
              );
            }
            if (modalAction === MODAL_ACTION.DELETE) {
              return (
                <ModalDeleteGroup
                  item={selectedItem}
                  onClose={onClose}
                  onDelete={() => {
                    deleteItem(selectedItem?.id);
                    closeModal(true);
                  }}
                />
              )

            }
          }}
        </ModalContent>
      </Modal>

      <Table
        aria-label="Grados y Secciones"
        color="primary"
        topContentPlacement="inside"
        topContent={
          <div className="flex flex-row justify-between items-center gap-4">
            <h3 className="text-xl font-medium">Grados y Secciones</h3>
            <Render condition={isFreelanceTeacher}>
              <div className='flex gap-2'>
                <Button
                  className="pr-2 bg-green font-medium text-white"
                  endContent={<IconPlus color="white" />}
                  onPress={() => onSelectItem(null, MODAL_ACTION.CREATE)}
                >
                  Nuevo
                </Button>

                <PaidAction>
                  <Button
                    className="pr-2 bg-green font-medium text-white"
                    endContent={<IconPlus color="white" />}
                    onPress={() => download()}
                  >
                    Descargar
                  </Button>
                </PaidAction>
              </div>
            </Render>
          </div>
        }
      >
        <TableHeader>
          <TableColumn>Año escolar</TableColumn>
          <TableColumn>Lapso</TableColumn>
          <TableColumn>Secciones</TableColumn>
          <TableColumn align="end" />
        </TableHeader>
        <TableBody items={data} emptyContent="No hay resultados">
          {(item) => {
            return (
              <TableRow key={item.id}>
                <TableCell className='capitalize'>{item?.name}</TableCell>
                <TableCell>
                  <span
                    className="cursor-pointer font-semibold text-sm text-secondary"
                    onClick={() => onSelectItem(item, MODAL_ACTION.VIEW_LAPSES)}
                  >
                    Ver
                  </span>
                </TableCell>
                <TableCell>
                  {!!item?.sections?.length ? (
                    <span
                      className="cursor-pointer font-semibold text-sm text-secondary"
                      onClick={() => onSelectItem(item, MODAL_ACTION.VIEW_SECTIONS)}
                    >
                      Ver
                    </span>
                  ) : (
                    <Render condition={isFreelanceTeacher}>
                      <Chip
                        variant="bordered"
                        color="success"
                        className="cursor-pointer"
                        onClick={() => onSelectItem(item, MODAL_ACTION.CREATE_MULTIPLE_SECTIONS)}
                      >
                        Agregar
                      </Chip>
                    </Render>
                  )}
                </TableCell>
                <TableCell align="right">
                  <Render condition={isFreelanceTeacher}>
                    <div className="relative flex justify-end items-center gap-2">
                      <Tooltip content="Editar">
                        <IconEdit onClick={() => onSelectItem(item, MODAL_ACTION.EDIT)} />
                      </Tooltip>
                      <Tooltip content="Eliminar" color="danger">
                        <IconTrash className="text-danger" onClick={() => onSelectItem(item, MODAL_ACTION.DELETE)} />
                      </Tooltip>
                    </div>
                  </Render>
                </TableCell>
              </TableRow>
            )
          }}
        </TableBody>
      </Table>


      <div className="flex w-full justify-center mt-4">
        <Pagination
          showControls
          variant="bordered"
          page={pagination.page}
          total={pagination.pages}
          onChange={goToPage}
        />
      </div>
    </div>
  );
}

const ModalViewLapses = ({ item }) => {

  const items = item?.lapses?.sort((a, b) => {
    const dateA = moment(a.init_date, 'YYYY-MM-DD');
    const dateB = moment(b.init_date, 'YYYY-MM-DD');

    return dateA.isBefore(dateB) ? -1 : 1;
  });


  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Año escolar {item.name}</ModalHeader>
      <ModalBody className="p-0 pb-4">
        <Table aria-label="Lapsos" removeWrapper isStriped classNames={{ th: '!rounded-none' }}>
          <TableHeader>
            <TableColumn>Nombre</TableColumn>
            <TableColumn>Inicio</TableColumn>
            <TableColumn>Finalización</TableColumn>
          </TableHeader>
          <TableBody items={items ?? []} emptyContent="No hay lapsos">
            {(lapse) => (
              <TableRow key={lapse.id}>
                <TableCell>{lapse.name}</TableCell>
                <TableCell>{moment(lapse.init_date).format('DD-MM-YYYY')}</TableCell>
                <TableCell>{moment(lapse.end_date).format('DD-MM-YYYY')}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </ModalBody>
    </>
  )
}

const ModalViewSections = ({ item, onSelectItem, onDelete, isFreelanceTeacher }) => {

  const [openDelete, setOpenDelete] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const closeModal = () => {
    setOpenDelete(false);
    setDeleteItem(null);
  }

  const onDeleteItem = (item) => {
    setOpenDelete(true);
    setDeleteItem(item);
  }


  const grades = Object.values(item.sections.reduce((acc, item) => {
    if (!acc[item.school_grade?.name]) {
      acc[item.school_grade?.name] = {
        name: item.school_grade?.name,
        type: item.school_grade?.type,
        id: item.school_grade?.id,
        sections: []
      };
    }

    acc[item.school_grade?.name].sections.push({ name: item.name, id: item.id });

    return acc;
  }, {})).map(grade => ({
    ...grade,
    sections: grade.sections.sort((a, b) => a.name.localeCompare(b.name))
  }));


  return (
    <>
      <Modal
        size="md"
        isOpen={openDelete}
        onClose={() => closeModal()}
        backdrop="blur"
        scrollBehavior="outside"
      >
        <ModalContent>
          {(onClose) => {
            return (<ModalDeleteGrade
              item={deleteItem}
              onClose={onClose}
              onDelete={() => {
                onDelete(deleteItem.id)
                closeModal();
                onSelectItem(null, MODAL_ACTION.NONE)
              }}
            />)
          }}
        </ModalContent>
      </Modal>

      <ModalHeader className="flex items-center gap-3">
        <span className="capitalize">{item.name}</span>
        <Render condition={isFreelanceTeacher}>
          <Tooltip content="Agregar">
            <IconPlus onClick={() => onSelectItem(null, MODAL_ACTION.CREATE_SECTION, item.id)} />
          </Tooltip>
        </Render>
      </ModalHeader>
      <ModalBody className="p-0 pb-4">
        <Table aria-label="Secciones" removeWrapper isStriped classNames={{ th: '!rounded-none' }}>
          <TableHeader>
            <TableColumn>Grados</TableColumn>
            <TableColumn>Secciones</TableColumn>
            <TableColumn align="end" />
          </TableHeader>
          <TableBody items={item.sections ?? []} emptyContent="No hay secciones">

            {grades.map((grade) => (
              <TableRow key={grade.id}>
                <TableCell>{grade.name}</TableCell>
                <TableCell className='uppercase'>{grade?.sections?.map(x => x.name).join(', ')}</TableCell>
                <TableCell align="right">
                  <Render condition={isFreelanceTeacher}>
                    <div className="relative flex justify-end items-center gap-2">
                      <Tooltip content="Editar">
                        <IconEdit onClick={() => onSelectItem(grade, MODAL_ACTION.CREATE_SECTION)} />
                      </Tooltip>
                      <Tooltip content="Eliminar" color="danger">
                        <IconTrash className="text-danger" onClick={() => onDeleteItem(grade)} />
                      </Tooltip>
                    </div>
                  </Render>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ModalBody>
    </>
  )
}

const ModalDeleteGroup = ({ item, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar este agrupamiento?. Puede que posea registros de horarios y materias asociadas, al eliminarse se eliminarán también dichos registros</p>
        <p className="text-center font-medium">{item.year}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}

const ModalDeleteGrade = ({ item, onClose, onDelete }) => {
  return (
    <>
      <ModalHeader className="flex flex-col gap-1">Confirmación</ModalHeader>
      <ModalBody>
        <p className="text-center">¿Estás seguro de eliminar el grado?. Puede que posea registros de horarios y materias asociadas, al eliminarse se eliminarán también dichos registros</p>
        <p className="text-center font-medium">{item.year}</p>
      </ModalBody>
      <ModalFooter className="justify-evenly">
        <Button variant="light" onPress={onClose}>Cancelar</Button>
        <Button color="danger" onPress={onDelete}>Aceptar</Button>
      </ModalFooter>
    </>
  )
}


const useFetchTable = (parentFilters) => {
  const initialPagination = {
    page: 1,
    pages: 1,
    total: 0,
    perPage: Constants.PER_PAGE,
  };


  const initialFilters = {
    page: 1,
    perPage: Constants.PER_PAGE,
    ...parentFilters
  };

  const user = useSelector((state) => state.user)
  const [data, setData] = useState([]);
  const [canFetch, setCanFetch] = useState(true);
  const [filters, setFilters] = useState(initialFilters);
  const [pagination, setPagination] = useState(initialPagination);


  const fetchData = async () => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      const response = await TeacherGroupService.groups.getGradesAndSections({ ...filters, user_id: user.id })
      const { data, ...rest } = response;

      setData(data);
      setPagination(rest);
      setCanFetch(true);

    } catch (error) {
      setData([]);
      onError(String(error));
    }
  }

  const download = async () => {
    setCanFetch(false);
    try {
      const response = await TeacherGroupService.groups.getGradesAndSections({ ...filters, user_id: user.id, download: true })
      if (response.url) {
        const link = document.createElement('a');
        link.href = response.url;
        link.download = response.url.split('/').pop();
        link.target = '_blank';
        link.click();
        link.remove();
      }
      setCanFetch(true);
    } catch (error) {
      onError(String(error));
    }
  }

  const deleteItem = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await TeacherGroupService.groups.deleteGroup({ professor_id: user.id, school_year_id: id });
      toast.success('Agrupamiento eliminado con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const deleteGrade = async (id) => {
    if (!canFetch) return;
    setCanFetch(false);

    try {
      await TeacherGroupService.groups.deleteGrade({ id });
      toast.success('Grado eliminado con éxito');
      fetchData();

    } catch (error) {
      onError(String(error));
    }
    setCanFetch(true);
  }

  const getCurrentPagination = () => {
    // Truco para obtener el estado actualizado (pagination es mantenida con el estado actual por el componente Pagination)
    let pag;
    setPagination(s => {
      pag = s;
      return s;
    });
    return pag;
  }

  const onError = (msg) => toast.error(msg);

  const reload = (inSamePage = false) => {
    setCanFetch(true);
    if (!inSamePage) setFilters(initialFilters);
    else fetchData();
  }

  const goToPage = (page) => {
    const pagination = getCurrentPagination();
    if (page >= 1 && page <= pagination.pages && page !== pagination.page) {
      setCanFetch(true);
      setFilters({ ...filters, page });
    }
  }

  const changePerPage = (perPage) => {
    setCanFetch(true);
    setFilters({ ...filters, perPage });
  }



  useEffect(() => {
    fetchData();
  }, [filters]);

  useEffect(() => {
    setFilters((s) => ({ ...s, ...parentFilters }))
  }, [parentFilters])

  return {
    changePerPage,
    data,
    deleteItem,
    goToPage,
    isLoading: !canFetch,
    pagination,
    reload,
    deleteGrade,
    user,
    download,
  }
}

export default Groups;
